import { render } from "./Music.vue?vue&type=template&id=4b6c40a4&ts=true"
import script from "./Music.vue?vue&type=script&lang=ts"
export * from "./Music.vue?vue&type=script&lang=ts"

import "./Music.vue?vue&type=style&index=0&id=4b6c40a4&lang=scss"

import exportComponent from "D:\\work\\fengmian\\Activity\\2023qixi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__